var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","color":"primary","dark":""}},[_c('v-tabs',{staticClass:"mx-auto"},[_c('v-tab',[_vm._v("Home")]),_c('v-tab',[_vm._v("Settings")])],1)],1),_c('v-content',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }